module.exports = __webpack_public_path__ + "static/worldVis-d6282182288147db9703b5d7219c6968.mp4";